import { configureStore } from "@reduxjs/toolkit";
import AuthSliceReducer from "./slices/authSlice";
import UserSignUpReducer from "./slices/UserSIgnUp";
import handleLogoutReducer from "./slices/authSlice";
import forgotPasswordSliceReducer from "./slices/ForgotPasswordSlice";
import VerifyOTPReducer from "./slices/VerifyOTP";
import ResetPasswordSliceReducer from "./slices/ResetPassword";
import UpdateUserProfileSliceReducer from "./slices/UpdateUserProfile";
import UpdateCorporateProfileSliceReducer from "./slices/UpdateCorporateProfileSlice";
import professionalUserUpdateSliceReducer from "./slices/professionalUserUpdate";
import ProfessionalAddServicesSliceReducer from "./slices/ProfessionalServcicesSlice";
import coporateAddEmployeSliceReducer from "./slices/CorporateAddEmployee";
import ProfessionalSheduleSliceReducer from "./slices/ProfessionalSheduleSlice";
import chatSliceReducer from "./slices/chatSlice";
import notificationReducer from "./slices/notificationSlice";
import requestReducer from "./slices/requestSlice";
import SearchFilterSliceReducer from "./slices/SearchFilterSlice";
import ManageRequestSliceReducer from "./slices/ManageRequestSlice";
import ChnagePasswordSliceReducer from "./slices/ChnagePasswordSlice";
import EmployeeServicesReducer from "./slices/employeeServices";
import SuperAdminCorporateSliceReducer from "./slices/superAdminCorporateSlice";
import superAdminProfessionalSliceReducer from "./slices/superAdminProfessionalSlice";
import superAdminUserSliceReducer from "./slices/SuperAdminUserSlice";
import superAdminProfileReviewReducer from "./slices/profileReviewSlice";
import availedServiceSliceReducer from "./slices/availedServiceSlice";
import feedbackSlice from "./slices/feedbackSlice";
import dashboardStatsSliceReducer from "./slices/dashboardStatsSlice";
import SubscriptionSlice from "./slices/subscriptionSlice";
import authUserSlice from "./slices/authUser";
import adminSubscriptionSliceReducer from "./slices/adminSubscriptionSlice";
import AdminProfileSliceReducer from "./slices/AdminProfileSlice";

export const store = configureStore({
  reducer: {
    AuthSlice: AuthSliceReducer,
    user: authUserSlice,
    UserSignUp: UserSignUpReducer,
    handleLogout: handleLogoutReducer,
    forgotPasswordSlice: forgotPasswordSliceReducer,
    VerifyOTP: VerifyOTPReducer,
    ResetPasswordSlice: ResetPasswordSliceReducer,
    UpdateUserProfileSlice: UpdateUserProfileSliceReducer,
    UpdateCorporateProfileSlice: UpdateCorporateProfileSliceReducer,
    professionalUserUpdateSlice: professionalUserUpdateSliceReducer,
    ProfessionalAddServicesSlice: ProfessionalAddServicesSliceReducer,
    coporateAddEmployeSlice: coporateAddEmployeSliceReducer,
    ProfessionalSheduleSlice: ProfessionalSheduleSliceReducer,
    chat: chatSliceReducer,
    notificaions: notificationReducer,
    requests: requestReducer,
    SearchFilterSlice: SearchFilterSliceReducer,
    ManageRequestSlice: ManageRequestSliceReducer,
    ChnagePasswordSlice: ChnagePasswordSliceReducer,
    EmployeeServices: EmployeeServicesReducer,
    SuperAdminCorporateSlice: SuperAdminCorporateSliceReducer,
    superAdminProfessionalSlice: superAdminProfessionalSliceReducer,
    superAdminUserSlice: superAdminUserSliceReducer,
    superAdminProfileReview: superAdminProfileReviewReducer,
    availedServiceSlice: availedServiceSliceReducer,
    feedbacks: feedbackSlice,
    dashboardStatsSlice: dashboardStatsSliceReducer,
    subscriptions: SubscriptionSlice,
    adminSubscriptions: adminSubscriptionSliceReducer,
    AdminProfileSlice: AdminProfileSliceReducer,
  },
});
